import { getCookie } from '@api/HelperAPI';

// TODO @k.anyabuike: Replace with new_offers_page_q1_2026 split test when created
export const isNewOffersPage = () => {
    return getCookie('newOffersPage') === 'True';
};
